import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import { StepStatus } from "../../../../constants/ComponentTypes";
import CompleteCircle from "../../../Icons/CompleteCircle";
import ActiveCircle from "../../../Icons/ActiveCircle";
import IncompleteCircle from "../../../Icons/IncompleteCircle";

const styles = () => ({
  root: {
    width: "100%",
    maxWidth: "547px",
    margin: "auto",
  },

  stepper: {
    background: "transparent",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  stepContainer: {
    display: "flex",
    alignItems: "center",
    minHeight: "25px",
    paddingBottom: "20px",
  },

  step: {
    position: "relative",
  },

  stepIcon: {},

  stepLabel: {
    fontSize: "13px",
    fontWeight: "bold",
    position: "absolute",
    whiteSpace: "nowrap",
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 120%)",
  },

  stepConnector: {
    width: "180px",
    flex: 2,
    borderTop: "2px solid #5593FF",
    margin: "-1px",
  },

  completed: {
    background: "red",
  },
});

class ProgressBar extends React.Component {
  getStepStatus = (i) => {
    const { step } = this.props;

    if (i - 1 < step) {
      return StepStatus.COMPLETED;
    } else if (i - 1 === step) {
      return StepStatus.ACTIVE;
    } else {
      return StepStatus.IMCOMPLETE;
    }
  };

  renderStepIcon = (status) => {
    switch (status) {
      case StepStatus.COMPLETED:
        return (
          <span>
            <CompleteCircle
              width={20}
              height={20}
              color="#5593FF"
              style={{ display: "block" }}
            />
          </span>
        );
      case StepStatus.ACTIVE:
        return (
          <span>
            <ActiveCircle
              width={20}
              height={20}
              color="#5593FF"
              style={{ display: "block" }}
            />
          </span>
        );
      case StepStatus.IMCOMPLETE:
        return (
          <span>
            <IncompleteCircle
              width={20}
              height={20}
              color="#D8DBDF"
              style={{ display: "block" }}
            />
          </span>
        );
      default:
        return;
    }
  };

  render() {
    const { classes, steps } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.stepper}>
          {steps.map((step, i) => {
            const status = this.getStepStatus(i);
            return (
              <div className={classes.stepContainer} key={i}>
                <div className={classes.step}>
                  <div className={classes.stepIcon}>
                    {this.renderStepIcon(status)}
                  </div>
                  <Typography variant="body2" className={classes.stepLabel}>
                    {step}
                  </Typography>
                </div>
                {i !== steps.length - 1 && (
                  <span
                    className={classes.stepConnector}
                    style={{
                      borderColor:
                        status === StepStatus.COMPLETED ? "#5593FF" : "#D8DBDF",
                    }}
                  ></span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.array,
  step: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default withStyles(styles)(ProgressBar);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/ProgressBar.jsx